
import { Palette, Gem } from 'lucide-react';
import { Product } from './types';

export const beautyFashionProducts: Product[] = [
  {
    id: 'fashion-design-software',
    title: 'Fashion Design Software',
    subtitle: 'Creative design platform',
    description: 'Professional fashion design software with pattern creation, 3D visualisation, fabric simulation, and collection management for UK fashion designers.',
    icon: Palette,
    image: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Retail & Fashion',
    status: 'Available',
    features: [
      'Pattern design tools',
      '3D visualisation',
      'Fabric simulation',
      'Collection management',
      'Size grading',
      'Technical drawings',
      'Colour management',
      'Export capabilities'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-purple-500 to-indigo-600',
    businessTypes: ['#fashion', '#design', '#3d-modeling', '#creative', '#apparel']
  },
  {
    id: 'jewelry-store-management',
    title: 'Jewelry Store Management System',
    subtitle: 'Luxury retail solution',
    description: 'Comprehensive jewelry store management with inventory tracking, appraisal management, customer relations, and security features.',
    icon: Gem,
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Retail & Fashion',
    status: 'Available',
    features: [
      'Inventory management',
      'Appraisal tracking',
      'Customer database',
      'Security features',
      'Repair tracking',
      'Sales analytics',
      'Certificate management',
      'Insurance integration'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-yellow-500 to-amber-600',
    businessTypes: ['#jewelry', '#luxury-retail', '#inventory', '#appraisal', '#security']
  }
];
